import { render, staticRenderFns } from "./TaxReturnCard.vue?vue&type=template&id=25d02ab0&scoped=true&"
import script from "./TaxReturnCard.vue?vue&type=script&lang=js&"
export * from "./TaxReturnCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d02ab0",
  null
  
)

export default component.exports